import { useContext } from "react";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../SaleDetailsDialog/styles.module.css";
import DateTimeHelpers from "helpers/DateTimeHelpers";
import { amountRoundOff } from "helpers/NumberFormatHelper";
import ShopContext from "context/ShopContext";

export default function DeleteCartDetailsPopup({ open, onClose, deletedCart }) {
  const { selectedShop } = useContext(ShopContext);

  if (!open || !deletedCart) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.popUp} onClick={handleBackdropClick}>
      <Grid container className={styles.billContentWrapper} onClick={(e) => e.stopPropagation()}>
        <Grid item xs={12} className={styles.headSec} mb={2}>
          <h3>Deleted Cart Details</h3>
          <CloseIcon className={styles.icon} onClick={onClose} />
        </Grid>

        <Grid item xs={12} className={styles.headInfoSec}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Cart Number</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>{deletedCart.cartNumber}</div>
              </div>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Total Amount</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>
                  <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
                  {amountRoundOff(deletedCart.amount || 0)}
                </div>
              </div>
            </Grid>

            <Grid item xs={6}>
              <div className={styles.priceTxt}>
                <div className={styles.subTitle}>Deleted Time</div>
                <div className={styles.colon}>:</div>
                <div className={styles.amountGray}>
                  {deletedCart.deletedAt ? DateTimeHelpers.formatDateTime(deletedCart.deletedAt) : "-"}
                </div>
              </div>
              {deletedCart.description && (
                <div className={styles.priceTxt}>
                  <div className={styles.subTitle}>Reason</div>
                  <div className={styles.colon}>:</div>
                  <div className={styles.amountGray}>{deletedCart.description}</div>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className={styles.tableContainer}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ width: "10%" }}>No</th>
                <th style={{ width: "40%" }}>Items</th>
                <th style={{ width: "10%" }}>Qty</th>
                <th style={{ width: "10%" }}>Rate</th>
                <th style={{ width: "10%" }}>Total</th>
                <th style={{ width: "20%" }}>Note</th>
              </tr>
            </thead>
            <tbody>
              {(deletedCart.items || []).map((item, index) => (
                <tr key={index}>
                  <td style={{ width: "10%" }}>{index + 1}</td>
                  <td style={{ width: "40%" }}>{item.name}</td>
                  <td style={{ width: "10%" }}>{item.count ?? item.qty ?? 1}</td>
                  <td style={{ width: "10%" }}>{amountRoundOff(item.rate || 0)}</td>
                  <td style={{ width: "10%" }}>{amountRoundOff(item.payable || 0)}</td>
                  <td style={{ width: "20%" }}>{item.note ?? "-"}</td>
                </tr>
              ))}
              {(!deletedCart.items || deletedCart.items.length === 0) && (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#999" }}>
                    No items found in this deleted cart
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Grid>
        <div style={{ height: "20px" }}></div>
      </Grid>
    </div>
  );
}
